import { createContext } from "react"

interface ContextType {
  selectedNodes: any[]
}

export const DashContext = createContext<ContextType>({
  selectedNodes: [],
})